import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import SVG from 'components/widgets/icons/svg';


export default function Resolve({ triageItem, updateTriageItem }) {
  return (
    <li
      onClick={() => updateTriageItem({ id: triageItem.id, status: 'Resolved' })}
      className={classNames('triage-option-resolve', { disabled: triageItem.status === 'Resolved' }, 'triage-option-header')}
    >
      <SVG src="svg/check.svg" className="triage-option-icon resolve" />
      Acknowledge OK
    </li>
  );
}

Resolve.propTypes = {
  triageItem: PropTypes.object.isRequired,
  updateTriageItem: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/components/models/triage/triage-items/triage-options/resolve.js